export const pesIconSizes = {
  NANO: 'nano',
  MICRO: 'micro',
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large',
  XLARGE: 'xlarge',
} as const;

export const ONLINE_SOFTWARE = 'Online Software';
export const PDP_SOFTWARE = 'Software';
export const ONLINE_CONFIGURATOR = 'Online Configurator';
export const CONFIGURATOR = 'Configurator';

export const CTA_TYPES = {
  ONLINE_SOFTWARE,
  PDP_SOFTWARE,
  ONLINE_CONFIGURATOR,
  CONFIGURATOR,
  BUY_ONLINE: 'buy-online',
  REQUEST_DEMO: 'request-demo',
  SOFTWARE_FREE_TRIAL: 'software-free-trial',
};

export const ONLINE_CTA_TYPES = {
  [ONLINE_SOFTWARE]: true,
  [ONLINE_CONFIGURATOR]: true,
  [CTA_TYPES.BUY_ONLINE]: true,
  [CTA_TYPES.REQUEST_DEMO]: true,
  [CTA_TYPES.SOFTWARE_FREE_TRIAL]: true,
};
